import { supabase } from './supabase';
import { PageNode, Connection } from '@/types/sitemap';

export interface DbSitemap {
  id: string;
  workspace_id: string;
  created_by: string | null;
  name: string;
  pages: PageNode[];
  connections: Connection[];
  thumbnail_url: string | null;
  created_at: string;
  updated_at: string;
}

export const sitemapService = {
  async getSitemapsByWorkspace(workspaceId: string): Promise<DbSitemap[]> {
    const { data, error } = await supabase
      .from('sitemaps')
      .select('*')
      .eq('workspace_id', workspaceId)
      .order('updated_at', { ascending: false });

    if (error) throw error;
    return (data || []) as DbSitemap[];
  },

  async getSitemapById(id: string): Promise<DbSitemap | null> {
    const { data, error } = await supabase
      .from('sitemaps')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data as DbSitemap | null;
  },

  async createSitemap(
    workspaceId: string,
    userId: string,
    name: string = 'Untitled Sitemap',
    id?: string
  ): Promise<DbSitemap> {
    const insertData: any = {
      workspace_id: workspaceId,
      created_by: userId,
      name,
      pages: [],
      connections: [],
    };
    
    if (id) {
      insertData.id = id;
    }

    const { data, error } = await supabase
      .from('sitemaps')
      .insert(insertData)
      .select()
      .single();

    if (error) throw error;
    return data as DbSitemap;
  },

  async saveSitemap(
    id: string,
    pages: PageNode[],
    connections: Connection[],
    thumbnailUrl?: string
  ): Promise<void> {
    const updates: any = { pages, connections };
    if (thumbnailUrl !== undefined) updates.thumbnail_url = thumbnailUrl;

    const { error } = await supabase
      .from('sitemaps')
      .update(updates)
      .eq('id', id);

    if (error) throw error;
  },

  async renameSitemap(id: string, name: string): Promise<void> {
    const { error } = await supabase
      .from('sitemaps')
      .update({ name })
      .eq('id', id);

    if (error) throw error;
  },

  async deleteSitemap(id: string): Promise<void> {
    const { error } = await supabase
      .from('sitemaps')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },
};
